import { Component } from "react";
import { connect } from "react-redux";
import TagsInput from "react-tagsinput";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import FormSelect from "components/DigiHapi/FormSelect";

import {
	SET_GOODDEALS_TITLE_FR,
	SET_GOODDEALS_PROMOTION_FR,
	SET_GOODDEALS_DESCRIPTION_FR,
	SET_TITLE_ERROR,
	SET_DESCRIPTION_ERROR,
	SET_GOODDEALS_OPENING_TIME_FR,
	SET_GOODDEALS_PRICE_FR,
	SET_GOODDEALS_CHOICES_TAGS,
	SELECT_GOODDEALS_ACTIVITY_CHOICE_FR,
	SET_GOODDEALS_ACTIVITY_DESCRIPTION_FR,
	SET_GOODDEALS_ACTIVITY_POST_DESCRIPTION_FR,
	SET_GOODDEALS_ACTIVITY_DESCRIPTION_ERROR,
	GOODDEALS_STEP2_VALIDATED
} from "actions/types";

class Step2 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const {
			dispatch,
			title,
			description,
			choices,
			activityDescription,
			templateId
		} = this.props;

		let success = true;
		if (!title) {
			dispatch({
				type: SET_TITLE_ERROR
			});
			success = false;
		}

		if (!description) {
			dispatch({
				type: SET_DESCRIPTION_ERROR
			});
			success = false;
		}

		if (choices) {
			for (const choice of Object.values(choices)) {
				if (!choice.description) {
					dispatch({
						type: SET_GOODDEALS_ACTIVITY_DESCRIPTION_ERROR,
						choiceId: choice.name
					});
					success = false;
					break;
				}
			}
		} else if (templateId && !activityDescription) {
			dispatch({
				type: SET_GOODDEALS_ACTIVITY_DESCRIPTION_ERROR
			});
			success = false;
		}

		if (success) {
			dispatch({
				type: GOODDEALS_STEP2_VALIDATED
			});
		}

		return success;
	}

	handleTags = choices => {
		const { dispatch } = this.props;

		dispatch({
			type: SET_GOODDEALS_CHOICES_TAGS,
			payload: choices
		});
	};

	render() {
		const {
			dispatch,
			title,
			titleErrorMsg,
			promotion,
			description,
			descriptionErrorMsg,
			price,
			openingTime,
			templateId,
			choices,
			choicesTags,
			choiceId,
			activityDescriptionErrorMsg,
			activityDescription,
			activityPostDescription
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDInput
						label="Titre *"
						id="title"
						fullWidth
						error={!!titleErrorMsg}
						helperText={titleErrorMsg ? titleErrorMsg : undefined}
						value={title ? title : ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_TITLE_FR,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description *"
						id="descrption-fr"
						fullWidth
						multiline
						rows={5}
						error={!!descriptionErrorMsg}
						helperText={descriptionErrorMsg ? descriptionErrorMsg : undefined}
						value={description ? description : ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_DESCRIPTION_FR,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Prix"
						id="price-fr"
						fullWidth
						multiline
						rows={3}
						value={price ? price : ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_PRICE_FR,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Promotion"
						id="promotion"
						fullWidth
						value={promotion ? promotion : ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_PROMOTION_FR,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Période d'ouverture / Horaires"
						id="opening-time-fr"
						fullWidth
						multiline
						rows={3}
						value={openingTime ? openingTime : ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_OPENING_TIME_FR,
								value: e.target.value
							})
						}
					/>
				</Grid>
				{templateId && (
					<>
						<Grid item xs={12}>
							<MDTypography variant="button" fontWeight="medium">
								Choix pour la recherche de partenaire
							</MDTypography>
							<TagsInput
								value={choicesTags}
								onChange={this.handleTags}
								tagProps={{
									className: "react-tagsinput-tag info"
								}}
								inputProps={{ placeholder: "Ajouter un choix" }}
							/>
						</Grid>
						{choices && (
							<Grid item xs={12}>
								<FormSelect
									label="Sélectionner le choix à mettre à jour"
									value={choiceId}
									placeholder="Choix"
									options={Object.values(choices).map(({ name }) => ({
										value: name,
										label: name
									}))}
									onChange={e =>
										dispatch({
											type: SELECT_GOODDEALS_ACTIVITY_CHOICE_FR,
											payload: e.target.value
										})
									}
								/>
							</Grid>
						)}
						<Grid item xs={12}>
							<MDInput
								label="Description *"
								id="description-fr"
								fullWidth
								multiline
								rows={5}
								error={!!activityDescriptionErrorMsg}
								helperText={activityDescriptionErrorMsg}
								value={activityDescription ? activityDescription : ""}
								onChange={e =>
									dispatch({
										type: SET_GOODDEALS_ACTIVITY_DESCRIPTION_FR,
										payload: e.target.value
									})
								}
							/>
						</Grid>
						<Grid item xs={12}>
							<MDInput
								label="Post photo description"
								id="post-description-fr"
								fullWidth
								multiline
								rows={3}
								value={activityPostDescription ? activityPostDescription : ""}
								onChange={e =>
									dispatch({
										type: SET_GOODDEALS_ACTIVITY_POST_DESCRIPTION_FR,
										payload: e.target.value
									})
								}
							/>
						</Grid>
					</>
				)}
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		title,
		titleErrorMsg,
		promotion,
		description,
		descriptionErrorMsg,
		price,
		openingTime,
		templateId,
		choices,
		choicesTags,
		choiceId,
		activityDescriptionErrorMsg,
		activityDescription,
		activityPostDescription
	} = state.gooddealReducer;
	return {
		title,
		titleErrorMsg,
		promotion,
		description,
		descriptionErrorMsg,
		price,
		openingTime,
		templateId,
		choices,
		choicesTags,
		choiceId,
		activityDescriptionErrorMsg,
		activityDescription,
		activityPostDescription
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step2
);
